import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import * as data from './../../assets/data/data.json';
import * as _ from 'lodash';

@Injectable()
export class ConstantService {
    PROTOCOL = location.protocol;
    BASE_URL = location.protocol + environment.api_base_url;
    LOGIN_URL = '/loginValidate/';
    RESET_PASSWORD_URL = '/reset_password/';
    CONTROLLERS = 'controllers/'
    COVID_NEW_PATIENT = this.CONTROLLERS + '/covid_patient_detail/';
    COVID_NEGATIVE_PATIENT = this.CONTROLLERS + '/covid_ra_negative/';
    COVID_NEW_PATIENT_WITH_FEEDBACK = this.CONTROLLERS + '/covid_patient_detail2/';
    COVID_PATIENT_FEEDBACK = this.CONTROLLERS + '/covid_patient_feedback/';
    GRIEVANCE = this.CONTROLLERS + '/petition/';
    GRIEVANCE_FEEDBACK = this.CONTROLLERS + '/petition_feedback/';
    CUSTOM_REPORT = 'customSearch/';
    AWW = this.CONTROLLERS + '/aww/';
    ASHA_WORKER = this.CONTROLLERS + '/asha_worker/';
    BPMU_STAFF = this.CONTROLLERS + '/bpmu_staff/';
    EMERGENCY_CONTACTS = this.CONTROLLERS + '/emergency_contacts/';
    WDC_STAFF = this.CONTROLLERS + '/lady_supervisior_wdc/';
    PROFILE = this.CONTROLLERS + '/users/';
    ICDS = this.CONTROLLERS + '/icds_detail/';
    CLINICS = this.CONTROLLERS + '/clinic_detail/';
    DEPARTMENT = this.CONTROLLERS + '/department/';
    SMS = '/smsBalance/';
    NEWS_UPLOAD_PATH = '/files/news.php';
    NEWS = this.CONTROLLERS + '/news/';
    MCP = this.CONTROLLERS + '/mcp/';
    MCP_MOTHER_DATA = this.CONTROLLERS + '/quaters/';
    GENERAL_ENQUIRY = this.CONTROLLERS + '/general_enquiry/';
    COOKIES = {
        TOKEN: '',
        PERMISSION: '',
        USERNAME: '',
        ID: '',
        TYPE: '',
    }



    BLOCKS = ['Balisankara', 'Bargaon', 'Bisra', 'Bonai', 'Gurundia', 'Hemgir', 'Koida',
     'Kuarmunda', 'Kutra', 'Lahunipada', 'Lathikata', 'Lephripada', 'Nuagaon', 'Rajgangpur', 'Subdega', 'Sundargarh', 'Tangarpalli'];
    MONTHS = [
        {num: '01', text: 'Jan'},
        {num: '02', text: 'Feb'},
        {num: '03', text: 'Mar'},
        {num: '04', text: 'Apr'},
        {num: '05', text: 'May'},
        {num: '06', text: 'Jun'},
        {num: '07', text: 'Jul'},
        {num: '08', text: 'Aug'},
        {num: '09', text: 'Sep'},
        {num: '10', text: 'Oct'},
        {num: '11', text: 'Nov'},
        {num: '12', text: 'Dec'},
      ]
    getCookies() {
        if (sessionStorage.token) {
            let cookies = atob(sessionStorage.token);
            let data = cookies.split('@');
            this.COOKIES = {
                TOKEN: data[0],
                PERMISSION: atob(data[2]),
                USERNAME: atob(data[1]),
                ID: atob(data[3]),
                TYPE: atob(data[5])
            }
        }
        console.log(this.COOKIES)
        return this.COOKIES;
    }
    constructor(private http: HttpClient) {
        console.log(location.protocol)
    }

    getCount(queryString) {
        return new Promise((resolve, rejects) => {
            this.http.get(this.BASE_URL + this.CUSTOM_REPORT + queryString + '/').subscribe((report) => {
                resolve(report);
            })
        })
    }

    getSMSBalance() {
        return new Promise((resolve) => {
            this.http.get(this.BASE_URL + this.SMS).subscribe((resp) => {
                resolve(resp);
            })
        })
    }

    getDataConstant(cat) {
        let dataConstant = (data as any).default;
        return dataConstant[cat];
    }
    
    
  arrangeMultiselectData(data, p1, p2) {
    let list: any = [];
    _.each(data, (item) => {
      list.push({ item_id: p1 ? item[p1] : item, item_text: p2 ? item[p2] : item})
    })
    let l = list
    return l;
  }


}